import React from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarGrauInstrucaoCpbsDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class GrausInstrucaoBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="GRAUS DE INSTRUÇÃO">
                    <DataGrid
                        dataSource={criarGrauInstrucaoCpbsDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} useIcons={true} />
                        <Column dataField={"id"} visible={false} />
                        <Column dataField={"sequencial"} caption={"#"} width={80} editorOptions={{readOnly:true}} sortOrder={"asc"} sortIndex={1}/>
                        <Column dataField={'descricao'} caption={"Descrição"} wordWrapEnabled={true} />
                        <Column dataField={'valorAnual'}
                            caption={"Valor Anual (R$)"}
                            dataType={"number"}
                            editorType={"dxNumberBox"}
                            format={"#,##0.00" }
                            editorOptions={{ format: "#,##0.00" }} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}